import {Box, Grid} from "@mui/material";
import {
	BreadcrumbItem,
	BreadcrumbLink,
	Breadcrumbs,
	defined,
	EditForm,
	TextField,
	View,
	ViewHeader,
} from "@variocube/app-ui";
import React, {useState} from "react";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {useCreditCardApi} from "../../api";
import {BcaSelect} from "../../component/bca-select";
import {CreditorSelect} from "../../component/creditor-select";
import {UserSelect} from "../../component/user-select";
import {useLocalization} from "../../i18n";

export function CreditCardNew() {
	const {s, t} = useLocalization();
	const {createCreditCard} = useCreditCardApi();
	const navigate = useNavigate();

	const [cardNumber, setCardNumber] = useState("");
	const [userId, setUserId] = useState<number | undefined>();
	const [inboxId, setInboxId] = useState<number | undefined>();
	const [creditorId, setCreditorId] = useState<number | undefined>();

	async function handleSave() {
		if (defined(userId) && defined(inboxId) && defined(creditorId)) {
			const {id} = await createCreditCard({
				cardNumber,
				userId,
				inboxId,
				creditorId,
				active: true,
			});
			navigate(`../${id}`, {relative: "path"});
		}
	}

	return (
		<View>
			<Breadcrumbs>
				<BreadcrumbLink component={RouterLink} to="..">{t("navigation.adminGroup.creditCards")}</BreadcrumbLink>
				<BreadcrumbItem>{t("creditCards.new.title")}</BreadcrumbItem>
			</Breadcrumbs>
			<ViewHeader title={t("creditCards.new.title")} />
			<EditForm loading={false} onSave={handleSave} labels={s("actions")}>
				<Box p={2}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<TextField
								label={t("creditCards.cardNumber")}
								fullWidth
								required
								value={cardNumber}
								onChange={setCardNumber}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<CreditorSelect
								label={t("creditCards.creditCardCompany")}
								value={creditorId}
								onChange={setCreditorId}
								required
								creditCardProvider
							/>
						</Grid>

						<Grid item xs={12} sm={6}>
							<BcaSelect
								value={inboxId}
								onChange={setInboxId}
								required
								filter={"CREDIT_CARD_MANAGEMENT"}
								label={t("invoices.details.bcaSelectHint")}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<UserSelect
								label={t("creditCards.user")}
								value={userId}
								onChange={setUserId}
								worksAt={inboxId}
								disabled={!defined(inboxId)}
								required
							/>
						</Grid>
					</Grid>
				</Box>
			</EditForm>
		</View>
	);
}
